<template>
  <v-card
    height="100%"
    :class="{
      'icon-pattern': !settings.isNonLitePlan
    }"
    flat
  >
    <v-card-text class="py-4 full-height">
      <v-row dense class="full-height">
        <v-col class="my-auto">
          <v-card-title class="py-0 px-1 secondary--text">
            Add Custom Category
          </v-card-title>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-col cols="auto" class="my-auto">
          <v-btn
            outlined
            color="secondary"
            @click="$emit('add')"
            v-if="settings.isNonLitePlan"
          >
            <v-icon class="mr-2">add_circle</v-icon> Add Category
          </v-btn>
          <v-btn v-else color="performance" to="/billing">
            Upgrade to enable
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  name: "AddCategoryCard",
  data: () => ({}),
  computed: {
    ...mapGetters({ settings: "profile/settings" })
  },
  created() {},
  methods: {}
};
</script>
